<template>
  <div class="dialog-body">
    <el-dialog
      title="仓储合同关闭提示"
      v-if="isPaid"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      center
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">该合同已完成结算，是否关闭</span>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <IELUploadBtn @upload="uploadHandler" text="上传附件" />
        <el-button type="primary" @click="handleSure(true)">确认</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="仓储合同关闭失败提示"
      ref="closeTip"
      v-else
      :visible.sync="dialogVisible3"
      append-to-body
      width="30%"
      center
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              >该合同未完成结算，无法关闭<br />请先关闭后续单据，再进行操作</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleStillClose">仍然关闭</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="仓储合同手动关闭提示"
      :visible.sync="dialogVisible1"
      append-to-body
      width="40%"
      center
    >
      <div class="result" style="text-align: center">
        <span style="text-align: center; display: block">该合同未完成结算，请填写关闭理由</span>
        <div style="margin: 20px 0"></div>
        <el-form :model="baseInfoData" :rules="rules" ref="closeReasonForm" label-width="120px">
          <el-form-item label="合同关闭原因" prop="contractCloseReason">
            <el-select
              v-model="baseInfoData.contractCloseReason"
              placeholder="请选择关闭原因"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in this.reasonList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="mark">
            <el-input type="textarea" v-model="baseInfoData.mark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure(false)">确认</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="仓储合同关闭成功提示"
      :visible.sync="dialogVisible2"
      append-to-body
      center
      width="30%"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              >该合同已关闭，是否复制该合同进行后续操作?</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClone">复制合同</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="仓储合同关闭失败提示"
      ref="closeTip"
      :visible.sync="dialogVisible4"
      append-to-body
      width="30%"
      center
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">该合同未创建结算，是否关闭</span>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure(true)">仍然关闭</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/park/contract';
  import XEUtils from 'xe-utils/methods/xe-utils';
  export default {
    name: 'closeContractDialog',
    props: ['isPaid', 'id', 'closeAttachments', 'isCreate'],
    data() {
      return {
        dialogVisible: false,
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        contractCloseReason: null,
        textarea: null,
        contractStatus: null,
        reasonList: [],
        attachments: [],
        closeId: null,
        baseInfoData: {
          contractCloseReason: null,
          mark: null,
        },
        rules: {
          contractCloseReason: [{ required: true, message: '关闭原因必填', trigger: ['change'] }],
        },
      };
    },
    mounted() {
      this.reasonList = this.dictListMap.warehouseContractCloseReason;
      this.closeId = this.$route.query.id;
      this.paid = this.isPaid;
    },
    methods: {
      openDialog() {
        if (!this.isCreate) {
          this.dialogVisible4 = true;
          return;
        }
        if (this.isPaid) {
          this.dialogVisible = true;
        } else {
          this.dialogVisible3 = true;
        }
      },
      // 关闭确认
      async handleSure(type) {
        if (type == true) {
          this.dialogVisible = false;
          this.dialogVisible3 = false;
          this.dialogVisible1 = false;
          this.dialogVisible4 = false;
          const { data } = await this.$axios.post(API.CLOSE_CONTRACT, {
            id: this.closeId,
            attachments: this.attachments,
          });
          console.log(data, '关闭请求之后的返回值');
          if (data.code == 0) {
            this.dialogVisible2 = true;
            this.$message.success('关闭成功!');
          } else {
            this.$message.error('关闭失败！');
          }
        } else {
          this.$refs.closeReasonForm.validate(async (valid) => {
            if (valid) {
              const { data } = await this.$axios.post(API.CLOSE_CONTRACT, {
                id: this.closeId,
                contractCloseReason: this.baseInfoData.contractCloseReason,
                remarks: this.baseInfoData.mark,
              });
              console.log(data, '关闭请求之后的返回值');
              if (data.code == 0) {
                this.dialogVisible2 = true;
                this.$message.success('关闭成功!');
              } else {
                this.$message.error('关闭失败！');
              }
              this.dialogVisible = false;
              this.dialogVisible3 = false;
              this.dialogVisible1 = false;
              this.dialogVisible4 = false;
            }
          });
        }
      },
      // 仍然关闭
      handleStillClose() {
        this.dialogVisible = false;
        this.dialogVisible3 = false;
        this.dialogVisible2 = false;
        this.dialogVisible4 = false;
        this.dialogVisible1 = true;
        this.baseInfoData = {};
      },
      // 关闭完成
      handleClose() {
        this.dialogVisible = false;
        this.dialogVisible3 = false;
        this.dialogVisible2 = false;
        this.dialogVisible1 = false;
        this.dialogVisible4 = false;
        this.$store.dispatch('tagsView/delView', {
          path: '/park/warehouse/contractDetail',
          name: 'contractDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        let path = {
          path: 'warehouse/contractList',
          name: 'contractList',
          meta: {
            keepAlive: true,
            title: '合同列表',
          },
        };
        this.$emit('closeOver');
        this.$router.push(path);
      },
      // 上传附件
      uploadHandler(fileObj) {
        this.attachments.push({
          attachmentName: fileObj.attachmentName,
          createBy: fileObj.createBy,
          gmtCreate: XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          attachmentKey: fileObj.attachmentKey,
          // attachmentId: fileObj.attachmentId,
          attachmentPath: fileObj.attachmentPath,
        });
      },
      // 取消
      handleCancel() {
        this.dialogVisible = false;
        this.dialogVisible3 = false;
        this.dialogVisible2 = false;
        this.dialogVisible1 = false;
        this.dialogVisible4 = false;
      },
      // 复制合同
      handleClone() {
        let path = {
          path: 'warehouse/contractMaintainance',
          name: 'contractMaintainance',
          meta: {
            keepAlive: true,
            title: '合同维护',
          },
          query: {
            pageMode: 0,
            id: this.id,
            isCopy: true,
          },
        };
        this.$router.push(path);
      },
    },
    watch: {
      id: {
        handler(val) {
          this.closeId = val ? val : null;
          console.log(this.closeId, '关闭合同的id');
        },
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  .textarea {
    float: right;
    width: 250px;
  }
</style>
